import { UserColumns, UserData, userEntityName } from '@/backend/features/authentication/shared';
import { useTranslation } from '@/ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import { Row } from '@juvare/platform-shared/features/storage';
import React from 'react';
import { useUserFormConfig } from './useUserFormConfig';

export function useHandleEditUser(row: Row<UserColumns>, reload: () => void) {
    const { t } = useTranslation();
    const userFormConfig = useUserFormConfig('edit');
    const userStorage = useStorageClient<UserData, UserColumns>(userEntityName);
    return React.useCallback(() => {
        showFormDialog({
            title: t('editUser', { name: row.columns.email }),
            config: userFormConfig,
            data: row.columns,
            onSubmit: (data) => {
                return userStorage
                    .post({ action: 'partial-update', id: row.id, data: { ...data, email: undefined } })
                    .then(() => reload())
                    .catch((error) => {
                        handleErrorDialog(error);
                        throw error;
                    });
            },
        });
    }, [row, reload, t, userFormConfig, userStorage]);
}
